import React from "react";
import { Link } from "react-router-dom";
import SEO from "@/components/SEO";

export default function ContactPage() {
  return (
    <>
      <SEO
        title="Contact"
        description="Get in touch with Bill Forge. Have questions about our invoicing software? Email us at info@codingwithdevam.cloud. We typically respond within 24 hours on business days."
        path="/contact"
      />
      <div className="bg-background">
      {/* Header */}
      <section className="py-20 bg-gradient-to-b from-primary/5 to-background">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl sm:text-5xl font-bold font-manrope mb-6">
            Get in Touch
          </h1>
          <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
            Have questions? We'd love to hear from you.
          </p>
        </div>
      </section>

      {/* Contact Section */}
      <section className="py-20 bg-background">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-card border border-border rounded-2xl p-8 md:p-12">
            <div className="text-center mb-8">
              <h2 className="text-2xl font-bold font-manrope mb-4">Contact Us</h2>
              <p className="text-muted-foreground">
                Send us an email and we'll get back to you as soon as possible.
              </p>
            </div>

            <div className="flex flex-col items-center justify-center space-y-6">
              <a
                href="mailto:info@codingwithdevam.cloud"
                className="flex items-center space-x-4 text-lg text-primary hover:text-primary/80 transition-colors"
              >
                <span className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center">
                  <span className="text-2xl">✉️</span>
                </span>
                <span className="font-medium">info@codingwithdevam.cloud</span>
              </a>

              <div className="text-center text-sm text-muted-foreground mt-4">
                <p>We typically respond within 24 hours on business days.</p>
              </div>
            </div>

            <div className="mt-12 pt-8 border-t border-border text-center">
              <p className="text-muted-foreground mb-4">
                Looking for something else?
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <Link
                  to="/pricing"
                  className="text-primary hover:text-primary/80 transition-colors"
                >
                  View Pricing →
                </Link>
                <Link
                  to="/about"
                  className="text-primary hover:text-primary/80 transition-colors"
                >
                  Learn About Us →
                </Link>
                <Link
                  to="/signup"
                  className="text-primary hover:text-primary/80 transition-colors"
                >
                  Start Free Trial →
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-primary text-primary-foreground">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl sm:text-4xl font-bold font-manrope mb-6">
            Ready to Get Started?
          </h2>
          <p className="text-xl opacity-90 mb-10">
            Join thousands of businesses using Bill Forge today.
          </p>
          <Link
            to="/signup"
            className="inline-block px-8 py-4 text-lg font-medium bg-background text-foreground rounded-lg hover:bg-background/90 transition-colors"
          >
            Start Free Trial
          </Link>
        </div>
      </section>
    </div>
    </>
  );
}
